module.exports = __webpack_public_path__ + "img/logo.e74c3308.png";